import store from './store'
import { AppSosoUtil } from 'kuaidong-lib'
import { Module, Mutation, VuexModule, getModule } from 'vuex-module-decorators'
import {
  Clazz,
  IJumpropeIntelligentClazz,
  IJumpropeIntelligentDevice,
  IJumpropeIntelligentStudentSelectable,
  JumpropeIntelligentConstants,
  JumpropeIntelligentInClassQuiz,
  JumpropeIntelligentInClassQuizClazz,
} from 'kuaidong-model'

type IDevice = IJumpropeIntelligentDevice & { state?: AppSosoUtil.DeviceState }

const WorkStyleTice = 'tice' // 体测的模式
const WorkStyleInClass = 'inClass' // 课堂测试
const WorkStyleAsYouWish = 'asYouWish' // 随心测

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: 'jumprope-intelligent',
})
class JumpropeIntelligentModule extends VuexModule {
  clazzId: number | null = null

  devices: IDevice[] = []
  // devices: IDevice[] = [
  //   {
  //     no: 123,
  //     device_id: '123',
  //     device_type: '123',
  //     group_name: '123',
  //     state: AppSosoUtil.DeviceState.Connected,
  //   },
  // ]

  // 所有的可选班级
  chooseClazzs: IJumpropeIntelligentClazz[] = []
  // 当前处理的班级
  currentClazz: IJumpropeIntelligentClazz | null = null
  // 当前班级下的所有学生信息
  students: IJumpropeIntelligentStudentSelectable[] = []

  _groupName = '' // 硬件跳绳的分组名称

  deviceType = '' // 硬件的设备类型

  workStyle = ''

  // 如果是课堂测试，会有课堂测验的相关配置
  currentInClazzQuiz: JumpropeIntelligentInClassQuiz | null = null

  // 测试方式， 定时定时, 目前仅随心测需要
  testEvent = ''
  testTarget = 60

  @Mutation
  reset() {
    this.devices = []
    this.clazzId = null
    this.students = []
    this.currentClazz = null
    this.chooseClazzs = []
    this.currentInClazzQuiz = null
  }

  @Mutation
  resetData() {
    this.clazzId = null
    this.students = []
    this.currentClazz = null
    this.chooseClazzs = []
    this.currentInClazzQuiz = null
  }

  @Mutation
  setClazzId(clazzId: number) {
    this.clazzId = clazzId
    this.currentClazz = this.chooseClazzs.find((c) => c.id === clazzId) || null
  }

  @Mutation
  setDevices(devices: IDevice[]) {
    this.devices = devices
    // 测试用fake 设备
    // this.devices = [
    //   {
    //     no: 123,
    //     device_id: '123',
    //     device_type: '123',
    //     group_name: '123',
    //     state: AppSosoUtil.DeviceState.Connected,
    //   },
    // ]
  }

  @Mutation
  setTiceStyle() {
    this.workStyle = WorkStyleTice
  }

  @Mutation
  setInClassStyle(options: { quiz: JumpropeIntelligentInClassQuiz; clazzs: JumpropeIntelligentInClassQuizClazz[] }) {
    this.currentInClazzQuiz = options.quiz
    this.workStyle = WorkStyleInClass
    this.chooseClazzs = options.clazzs.map((c) => {
      return {
        ...c.clazz,
        jump_completed_student_count: c.count,
        jump_uncompleted_student_count: c.total - c.count,
      }
    })
    this.students = []
  }

  @Mutation
  setAsYouWishStyle(options: { event: string; target: number }) {
    this.workStyle = WorkStyleAsYouWish
    this.testEvent = options.event
    this.testTarget = options.target
  }

  @Mutation
  updateDevice(devices: IDevice) {
    const existDevice = this.devices.find((d) => d.device_id === devices.device_id)
    if (existDevice) {
      existDevice.state = devices.state
    } else {
      this.devices.push(devices)
    }
  }

  @Mutation
  setStudents(students: IJumpropeIntelligentStudentSelectable[]) {
    this.students = students
  }

  @Mutation
  updateStudents(students: IJumpropeIntelligentStudentSelectable[]) {
    students.forEach((s) => {
      const index = this.students.findIndex((ts) => ts.student_enrollment_no === s.student_enrollment_no)
      if (index !== -1) {
        this.students.splice(index, 1, s)
      } else {
        this.students.push(s)
      }
    })
  }

  @Mutation
  updateStudentScore(studentOption: { studentNo: string; count: number; time: number }) {
    const stu = this.students.find((s) => s.student_enrollment_no === studentOption.studentNo)
    if (stu) {
      stu.best_jump_count = studentOption.count
      stu.best_score_duration_in_ms = studentOption.time
      // console.log('updateStudentScore', stu.full_name, stu.best_jump_count, stu.best_score_duration_in_ms)
    }
  }

  @Mutation
  setGroupName(groupName: string) {
    this._groupName = groupName
    localStorage.setItem('jumprope-intelligent-groupName', groupName)
  }

  @Mutation
  setDeviceType(deviceType: string) {
    this.deviceType = deviceType
  }

  // 废弃!!
  get activeDevices() {
    return this.devices.filter((d) => d.state === AppSosoUtil.DeviceState.Connected).sort((a, b) => a.no - b.no)
  }

  get isDeviceTypeCC() {
    // 类型为中控
    return this.deviceType === JumpropeIntelligentConstants.DeviceTypeCC
  }

  get groupNname() {
    return this._groupName || localStorage.getItem('jumprope-intelligent-groupName') || ''
  }

  get isInClazzQuiz() {
    return this.workStyle === WorkStyleInClass
  }

  get isAsYouWishStyle() {
    return this.workStyle === WorkStyleAsYouWish
  }

  get hasCurrentClazz() {
    return !!this.currentClazz
  }

  get selectedStudents() {
    return this.students.filter((s) => s.selected)
  }

  get testJumpRopeSeconds() {
    return this.jumpEvent.target
  }

  get isCountEvent() {
    // 计数跳绳
    return this.jumpEvent.event_type === JumpropeIntelligentConstants.EventGroupCount
  }

  get jumpEvent() {
    if (this.isAsYouWishStyle) {
      return {
        event_type: this.testEvent,
        target: this.testTarget,
      }
    } else if (this.isInClazzQuiz) {
      return this.currentInClazzQuiz!.event
    } else {
      return {
        event_type: JumpropeIntelligentConstants.EventGroupTime,
        target: 60,
      }
    }
  }

  get countTarget() {
    return this.jumpEvent.target
  }
}

export default getModule(JumpropeIntelligentModule)
